import { NgModule } from '@angular/core';
import { LazyViewDirective } from './lazy-view.directive';

/**
 * This `@NgModule` should be included in the `imports: [ ... ]` for
 * the parent `@NgModule`, that wants to lazy-load another `@NgModule`
 * using the `LazyViewComponent` (`<ng-container></ng-container>`)
 */
@NgModule({
    declarations: [
        LazyViewDirective
    ],
    exports: [
        LazyViewDirective
    ]
})
export class LazyViewModule { }
